import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';

export default function ScrollableBoxCustom({
    children,
    styled,
}: {
    children: React.ReactNode;
    styled?: SxProps<Theme>;
}) {
    return (
        <Box
            sx={{
                maxHeight: '60vh',
                overflowY: 'auto',
                pb: 2,
                '&::-webkit-scrollbar': {
                    width: '8px',
                    height: '8px',
                    backgroundColor: 'transparent',
                },
                '&::-webkit-scrollbar-track': {
                    backgroundColor: 'transparent',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    borderRadius: '4px',
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    },
                },
                '&:not(:hover)::-webkit-scrollbar-thumb': {
                    opacity: 0,
                    transition: 'opacity 0.3s ease-in-out',
                },
                '&:hover::-webkit-scrollbar-thumb': {
                    opacity: 1,
                    transition: 'opacity 0.3s ease-in-out',
                },
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
                marginRight: '-8px',
                paddingRight: '8px',
                ...styled,
            }}
        >
            {children}
        </Box>
    );
}
